define('modules/profiles/subviews/views/profile.salesforce.drawer',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/profiles/models/salesforce.identity.details.model',
    'modules/salesforce/drawer/views/base.salesforce.drawer',
    'modules/profiles/subviews/views/profile.salesforce.export.view',
    'modules/profiles/subviews/views/profile.salesforce.link.view'
], function(
    Prospector,
    $, _,Backbone,
    SalesforceIdentityModel,
    BaseSalesforceDrawer,
    SalesforceExportSubView,
    ProfileSalesforceLinkSubView
){
    var ProfileSalesforceDrawer = BaseSalesforceDrawer.extend({
        procResponse:function(){
            this.displayView = null;
            if(this.model.get('hasActiveSFSession')){
                window.utils.eraseCookie('SFDCSuccessLink');
                if(this.parent.model.salesForceData != undefined){
                    this.buildExportView();
                } else {
                    this.parent.model.salesForceData = new SalesforceIdentityModel({id: this.parent.model.get('id')});
                    this.listenTo(this.parent.model.salesForceData, 'sync', this.buildExportView, this);
                    this.parent.model.salesForceData.fetch();
                }
            }  else {
                this.buildLinkView();
                $(this.el).empty().append(this.displayView.render().el);
            }
        },
        hideLoader:function(){
            $('.profileload').remove();
            $('.searchViewHolder').show();
        },
        buildExportView:function(){
            this.displayView = new SalesforceExportSubView({parent: this.parent});
            $(this.el).append(this.displayView.render().el);
            this.hideLoader();
        },
        buildLinkView:function(){
            this.displayView = new ProfileSalesforceLinkSubView({parent: this.parent});
            this.hideLoader();
        },
        mainBtn:function(){

        }
    });
    return ProfileSalesforceDrawer;
});
